import { useTranslation } from '@ecomm/i18n'
import type { MonitoringChoiceType } from '../types'
import { SkipThisStepModal } from './SkipThisStepModal'

type BottomContentProps = {
  readonly monitoringChoice: MonitoringChoiceType
}
export function BottomContent({ monitoringChoice }: BottomContentProps) {
  const { t } = useTranslation('maps')

  return (
    <section
      className="text-center flex flex-col gap-3 mb-20 mt-4"
      data-testid="MonitoringBottomContent"
    >
      {monitoringChoice === 'choose-monitoring' ? (
        <SkipThisStepModal />
      ) : (
        <p>
          <a href="/cart" rel="noreferrer" target="_self">
            {t(`change-monitoring.return-to-cart`)}
          </a>
        </p>
      )}
      <p>{t(`${monitoringChoice}.business.bottom-content.recommendation`)}</p>
      <p className="font-medium">
        {t(`${monitoringChoice}.business.bottom-content.no-contract`)}
      </p>
      <p>{t(`${monitoringChoice}.business.bottom-content.protection-msg`)}</p>
      <p>
        {t(`${monitoringChoice}.business.bottom-content.signature-msg`)}
        <a href="/terms-of-service" rel="noreferrer" target="_self">
          {t(`${monitoringChoice}.business.bottom-content.terms-of-service`)}
        </a>
      </p>
    </section>
  )
}
